import {
  WSFlexBox,
  WSGrid,
  WSIconList,
  WSMarginProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useDefaultCurrency } from "../../../../shared/hooks/useDefaultCurrency";

import styles from "./styles.module.scss";

type Props = WSMarginProps;

export const PayableColumnsStackedView: React.FC<Props> = props => {
  const defaultCurrency = useDefaultCurrency();

  const requiredFields = [
    "Email or external ID",
    `Amount (${defaultCurrency})`,
    "Line item title",
    "Due date (or Pay date if paid)"
  ];
  const optionalFields = [
    "Line item description",
    "Reimbursable",
    "Invoice notes",
    "Attachment ID",
    "Payment reference ID"
  ];

  return (
    <WSGrid gutter="S" {...props}>
      <WSGrid.Item span={{ xs: "12", s: "6" }}>
        <WSFlexBox.CenterY mb="M">
          <WSText.ParagraphSm color="gray500" className={styles.title}>
            Required
          </WSText.ParagraphSm>
        </WSFlexBox.CenterY>
        <WSIconList.Checks
          items={requiredFields}
          iconProps={{
            name: "check-circle",
            color: "green400"
          }}
          textProps={{
            kind: "ParagraphSm"
          }}
          mb="XL"
        />
      </WSGrid.Item>
      <WSGrid.Item span={{ xs: "12", s: "6" }}>
        <WSText.ParagraphSm color="gray500" mb="M">
          Optional
        </WSText.ParagraphSm>
        <WSIconList.Checks
          items={optionalFields}
          iconProps={{
            name: "info-circle",
            color: "gray500"
          }}
          textProps={{
            kind: "ParagraphSm"
          }}
          mb="XL"
        />
      </WSGrid.Item>
    </WSGrid>
  );
};
